import { gql } from "@apollo/client";

export const ADD_APPOINTMENT_V2 = gql`
  mutation addAppointmentV2($data: AddAppointmentRequestInput!) {
    addAppointmentV2(
      addAppointmentData: $data,
    ) {
        appointments {
            start_at
            duration
            end_at
            appointmentCreateType
            promoCode
            resources {
                id
                name
            }
            pet {
              id,
              name,
              image,
              speciesName,
              breedName,
              species,
              breed,
              gender,
              reasonForVisit,
            }
        }
      destination_address,
      slotUnavailable,
      pets {
              id,
              name,
              image,
              speciesName,
              breedName,
              species,
              breed,
              gender,
              reasonForVisit,
      },
      location {
        idLocation,
        locationName,
        address,
        city,
        position {
          lat,
          lng,
        },
        email,
        phoneNumber,
        timeZone,
      },
      success,
      messages
    }
  }
`;
